import { Fragment } from 'react';
import { CartItem } from '.';
import type { CartGetItem } from 'src/types';

type Props = {
  cartItems?: CartGetItem[];
  cartCCY?: string;
  cartCCYS?: string;
  cartVendor: string;
  cartLocale?: string;
  page?: 'get' | 'review' | 'receive' | 'embed';
  missingAsins?: string[];
};

export const CartItemsList = ({
  cartItems = [],
  cartCCY = 'USD',
  cartCCYS = '$',
  cartVendor,
  cartLocale = 'us',
  page = 'get',
  missingAsins = [],
}: Props) => {
  return (
    <ul className='flex w-full flex-col items-center justify-center'>
      {cartItems.map((item, i) => {
        const isMissing = missingAsins.includes(item.asin);
        return (
          <Fragment key={`${item.asin},${i}` || i}>
            <CartItem
              item={item}
              ccy={cartCCY}
              ccys={cartCCYS}
              vendor={cartVendor}
              compare={false}
              locale={cartLocale}
              page={page}
              isMissing={isMissing}
            />
          </Fragment>
        );
      })}
    </ul>
  );
};
